import React, { useState, useEffect } from "react";
import Header from "./Header";
// import Sidebar from "./components/Sidebar";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";
import AskPineWidget from "./AskPineWidget";

function MainLayout({ children }) {
  const [globalLoading, setGlobalLoading] = useState(false);
  const [showTimeoutMessage, setShowTimeoutMessage] = useState(false);
  const token = localStorage.getItem("token");
  const [compactMode, setCompactMode] = useState(false);

  useEffect(() => {
    // setShowTimeoutMessage(false);
    let timeout;
    if (globalLoading) {
      timeout = setTimeout(() => {
        setShowTimeoutMessage(true);
      }, 12000); // 12 seconds
    } else {
      setShowTimeoutMessage(false);
    }

    return () => clearTimeout(timeout);
  }, [globalLoading]);

  return (
    <div className={`main-wrapper ${compactMode ? "compact-mode" : ""}`}>
      <Header
        compact_mode={(e) => {
          setCompactMode(e);
        }}
      />
      {globalLoading && (
        <div id="global-loader">
          <div className="page-loader"></div>
          {showTimeoutMessage && (
            <div
              style={{
                color: "#F37438",
                marginTop: "10px",
                textAlign: "center",
              }}
            >
              <br />
              This is taking longer than expected. Please wait...
            </div>
          )}
        </div>
      )}
      {/* <Sidebar /> */}
      <div className="page-wrapper" style={{ minheight: "285px" }}>
        {/* {React.cloneElement(children, { setGlobalLoading, token })} */}
        <Outlet context={{ setGlobalLoading, token }} />
        <Footer />
      </div>
      <AskPineWidget token={token} />
    </div>
  );
}

export default MainLayout;
